import { render, staticRenderFns } from "./NsdRegionForm.vue?vue&type=template&id=4d570d28"
import script from "./NsdRegionForm.vue?vue&type=script&lang=js"
export * from "./NsdRegionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports